export default __webpack_public_path__ + "static/media/mario.ae8a19ed.png";